import { render } from "./DiTu.vue?vue&type=template&id=766e54ed&scoped=true"
import script from "./DiTu.vue?vue&type=script&lang=js"
export * from "./DiTu.vue?vue&type=script&lang=js"

import "./DiTu.vue?vue&type=style&index=0&id=766e54ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766e54ed"]])

export default __exports__